import {
  FilterReducerAction,
  FilterReducerState,
  IdValuePair,
} from 'reducers/GenericFiltersReducer/GenericFiltersReducer.d'
import React, { ReactElement, useState } from 'react'
import FilterRow from './FilterRow'
import FilterPills from './FilterPills'
import clsx from 'clsx'
import { WppActionButton, WppIconChevron } from '@wppopen/components-library-react'
import styles from './Filters.module.scss'
import useLocalStorage from 'hooks/useLocalStorage'
import { LOCAL_STORAGE_KEYS } from 'utils/constants'

export interface FiltersProps {
  reducerState: FilterReducerState
  reducerDispatch: React.Dispatch<FilterReducerAction>
  isTargetApiLoading: boolean
  filtersId: string
  shouldDisplayPills?: boolean
  isJustified?: boolean
  groupInputs?: boolean
  groupInputKeys?: IdValuePair[]
  isCollapsable?: boolean
  localStorageKey?: string
  isItNotGrowLast?: boolean
  children?: ReactElement | null
  initialisation?: {
    isInitialising: boolean
    skeletonCount?: number
  }
  permissions?: null | {
    canGetEntity: boolean
  }
}

function Filters({
  reducerState,
  reducerDispatch,
  isTargetApiLoading,
  filtersId,
  shouldDisplayPills = false,
  isJustified = false,
  groupInputs = false,
  groupInputKeys = [],
  isCollapsable = false,
  localStorageKey = '',
  isItNotGrowLast,
  permissions,
  initialisation,
  children,
}: FiltersProps) {
  const { index } = reducerState
  const { value, setLocalStorageValue } = useLocalStorage<Record<string, boolean>>(
    LOCAL_STORAGE_KEYS.FILTERS_EXPANSION_CONFIG,
    {
      [localStorageKey]: true,
    },
  )

  const [isExpanded, setIsExpanded] = useState<boolean>(value[localStorageKey])

  const handleExpandToggle = () => {
    setIsExpanded(!isExpanded)
    setLocalStorageValue({ ...value, [localStorageKey]: !isExpanded })
  }
  return (
    <div className={styles.filter__container} data-testid="filters-container">
      {isCollapsable && (
        <WppActionButton
          className={clsx(styles.filtersDisplayToggle)}
          data-testid="filters-collapse-toggle-btn"
          onClick={handleExpandToggle}
        >
          Filters{' '}
          <WppIconChevron direction="right" slot="icon-start" className={clsx(isExpanded && styles.filtersExpanded)} />
        </WppActionButton>
      )}
      <div className={clsx(styles.filterRow, isCollapsable && !isExpanded && styles.filtersCollapsed)}>
        <FilterRow
          filtersData={Object.values(index)}
          reducerDispatch={reducerDispatch}
          isLoading={isTargetApiLoading}
          filtersId={filtersId}
          className={clsx(
            isJustified && styles.justify,
            !initialisation?.isInitialising && children
              ? styles.growBeforeSlot
              : isItNotGrowLast
                ? ''
                : styles.growLast,
            Object.values(index).length > 4 && styles.condensedRow,
          )}
          groupInputs={groupInputs}
          groupInputKeys={groupInputs ? groupInputKeys : []}
          permissions={permissions}
          initialisation={initialisation}
        >
          {children || <></>}
        </FilterRow>
      </div>
      {shouldDisplayPills && (
        <FilterPills reducerState={reducerState} reducerDispatch={reducerDispatch} filtersId={filtersId} />
      )}
    </div>
  )
}

export default Filters
